<template>
  <div id="sell-cart" class="columns">
    <div class="column">
      <h2 class="subtitle">Buylist Cart</h2>
      <div v-if="notification" class="notification is-info">
        <button @click="notification = ''" class="delete"></button>
        {{ notification }}
      </div>
      <div v-if="error" class="notification is-error">
        <button @click="error = ''" class="delete"></button>
        {{ error }}
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="100">Qty</th>
            <th>Name</th>
            <th>Set</th>
            <th>Condition</th>
            <th>Item Price</th>
            <th>Total Price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="li in cart">
            <td><input class="input" type="number" v-model.number="li.quantity" @change="updateLineItemQuantity(li)"></td>
            <td>{{ li.card_name }}</td>
            <td>{{ li.set_name }}</td>
            <td>{{ li.condition }}</td>
            <td>{{ li.buylist_price }}</td>
            <td>${{ linePrice(li) }}</td>
            <td><a @click.prevent="removeFromCart(li)" class="button is-primary">Delete</a></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5"></td>
            <td>${{ subtotal }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5"></td>
            <td><a @click.prevent="clearCart" class="button is-primary">Clear Order</a></td>
            <td><a @click.prevent="showConfirmation = true" class="button is-primary">Send Buylist Order</a></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-bind:class="{'is-active': showConfirmation}" class="modal">
			<div class="modal-background"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">Submit buylist order</p>
					<button class="delete" @click="showConfirmation = false"></button>
				</header>
				<section class="modal-card-body">
          <p><em>IMPORTANT</em></p>
          <p>Before submitting your buylist order, we will email you confirmation.<br>DO NOT SEND BEFORE RECEIVING CONFIRMATION.</p>
          <p>Before sending, ensure your cards are in the exact same order as listed below.</p>
          <p><em>PRINT OUT THIS PAGE AND INCLUDE IT WITH YOUR SHIPMENT.<br>THIS WILL BE YOUR ONLY CHANCE!</em></p>
          <hr>
          <ul>
            <li v-for="li in cart">{{ li.quantity }}x {{ li.condition }} {{ li.card_name }} - {{ li.set_name }}</li>
          </ul>
          <hr>
          <p>Once confirmed, ship the order to:</p>
          <address>
            PowerNine - Buying<br>
            341 State Street<br>
            Madison, WI 53703<br>
            United States
          </address>
				</section>
				<footer class="modal-card-foot">
          <p class="control is-expanded">
            <input class="input" style="width: 50%" type="text" v-model="buylistFrom" placeholder="Enter Email">
            <a @click.prevent="checkoutCart" :disabled="!validSeller" class="button is-primary">Submit Buylist Order</a>
          </p>
				</footer>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'SellCart',
  data() {
    return {
      cart: [],
      showConfirmation: false,
      buylistFrom: null,
      notification: null,
      error: null,
    };
  },
  computed: {
    subtotal() {
      return this.cart.reduce((acc, li) => Number(this.linePrice(li)) + acc, 0).toFixed(2);
    },
    validSeller() {
      if (!this.buylistFrom) {
        return false;
      }

      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.buylistFrom);
    },
  },
  methods: {
    linePrice(li) {
      return (Number(li.buylist_price.substr(1)) * li.quantity).toFixed(2);
    },
    clearCart() {
      this.cart = [];
      this.$localStorage.set('buylistProducts', this.cart);
    },
    updateLineItemQuantity() {
      this.$localStorage.set('buylistProducts', this.cart);
    },
    removeFromCart(li) {
      const i = this.cart.findIndex(l => l.uuid === li.uuid);
      this.cart.splice(i, 1);
      this.$localStorage.set('buylistProducts', this.cart);
    },
    checkoutCart() {
      this.axios.post('https://inventory.powernine.com/shopify/buylist-order', {
        from: this.buylistFrom,
        contents: this.cart,
      }).then(() => {
        this.clearCart();
        this.showConfirmation = false;
        this.notification = 'You\'ve successfully submitted your buylist order. We\'ll email you with the order status soon.';
      }).catch((err) => {
        this.error = 'Something went wrong submitting. Please try again.';
        throw err;
      });
    },
  },
  mounted() {
    let c = this.$localStorage.get('buylistProducts');
    if (!c) {
      this.$localStorage.set('buylistProducts', []);
      c = [];
    }

    c.sort((a, b) => Number(a.sort_order) - Number(b.sort_order));

    this.cart = c;
  },
};
</script>



// WEBPACK FOOTER //
// SellCart.vue?027a3af4